import { BaseModal } from '../BaseModal';
import { ModalBody } from '../ModalBody';
import { ModalProps } from './Modal.model';

export const Modal = ({ context, meta, data }: ModalProps) => {
  const { key, abort, isActive, zIndex } = context;
  const { title, text, highlights, successAction, abortAction, icon } = data;
  const { onSuccess, onAbort, onClose, actionType, isDisabled } = meta;

  return (
    <BaseModal
      key={key}
      abort={() => {
        onAbort();
        abort();
      }}
      abortAction={abortAction}
      close={() => {
        onClose();
        abort();
      }}
      isActive={isActive}
      isDisabled={isDisabled}
      success={() => {
        onSuccess();
        abort();
      }}
      successAction={successAction}
      title={title}
      zIndex={zIndex}>
      <ModalBody
        bot={actionType}
        botImg={icon}
        highlights={highlights}
        text={text}
      />
    </BaseModal>
  );
};
